import { useEffect } from 'react';

export const useSEO = (title, description, options = {}) => {
  useEffect(() => {
    document.title = title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', description);
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', window.location.origin + window.location.pathname);
    const values = { 'og:title': options.ogTitle || title, 'og:description': options.ogDescription || description, 'og:url': window.location.origin + window.location.pathname, ...(options.image ? { 'og:image': new URL(options.image, window.location.origin).href } : {}) };
    Object.entries(values).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) { tag = document.createElement('meta'); tag.setAttribute('property', property); document.head.appendChild(tag); }
      tag.setAttribute('content', content);
    });
  }, [title, description, options.image, options.ogDescription, options.ogTitle]);
};
